import {
  GET_FINANCE_REPORT,
  GET_FINANCE_REPORT_DETAIL_LIST,
  GET_FINANCE_REPORT_DETAIL_LIST_FAIL,
  GET_FINANCE_REPORT_DETAIL_LIST_SUCCESS,
  GET_FINANCE_REPORT_FAIL,
  GET_FINANCE_REPORT_SUCCESS,
  GET_SERVICE_REPORT,
  GET_SERVICE_REPORT_FAIL,
  GET_SERVICE_REPORT_SUCCESS,
  RESET_FINANCE_REPORT_FLAG,
  RESET_FINANCE_REPORT_LST,
  UPDATE_FINANCE_REPORT_DETAIL,
  UPDATE_FINANCE_REPORT_DETAIL_FAIL,
  UPDATE_FINANCE_REPORT_DETAIL_SUCCESS,
  UPSERT_FINANCE_REPORT,
  UPSERT_FINANCE_REPORT_FAIL,
  UPSERT_FINANCE_REPORT_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  lstFinanceReport: [],
  lstFinanceReportDetail: [],
  lstServiceReport: [],
  error: null,
  success: null,
  loading: false,
}

const updateFinanceDetailList = (lstFinanceReportDetail, payload) => {
  const findIndex = lstFinanceReportDetail.findIndex(x => x.id === payload.id)
  if (findIndex !== -1) {
    const {
      quarter1Amount,
      quarter2Amount,
      quarter3Amount,
      quarter4Amount,
      des1,
    } = payload
    lstFinanceReportDetail[findIndex].quarter1Amount = quarter1Amount
    lstFinanceReportDetail[findIndex].quarter2Amount = quarter2Amount
    lstFinanceReportDetail[findIndex].quarter3Amount = quarter3Amount
    lstFinanceReportDetail[findIndex].quarter4Amount = quarter4Amount
    lstFinanceReportDetail[findIndex].des1 = des1
  }
  return lstFinanceReportDetail
}

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPSERT_FINANCE_REPORT:
    case GET_FINANCE_REPORT:
    case GET_FINANCE_REPORT_DETAIL_LIST:
    case UPDATE_FINANCE_REPORT_DETAIL:
    case GET_SERVICE_REPORT:
      return {
        ...state,
        loading: true,
      }

    case UPSERT_FINANCE_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
      }

    case GET_FINANCE_REPORT_SUCCESS:
      return {
        ...state,
        lstFinanceReport: action.payload,
        success: "لیست مالی بارگذاری شد",
        error: null,
        loading: false,
      }

    case GET_SERVICE_REPORT_SUCCESS:
      return {
        ...state,
        lstServiceReport: action.payload,
        success: "لیست مالی بارگذاری شد",
        error: null,
        loading: false,
      }

    case GET_FINANCE_REPORT_DETAIL_LIST_SUCCESS:
      return {
        ...state,
        lstFinanceReportDetail: action.payload,
        success: "جزئیات مالی بارگذاری شد",
        error: null,
        loading: false,
      }
    case UPDATE_FINANCE_REPORT_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        lstFinanceReportDetail: updateFinanceDetailList(
          state.lstFinanceReportDetail,
          action.payload
        ),
        success: "به روز رسانی انجام شد",
      }

    case UPSERT_FINANCE_REPORT_FAIL:
    case UPDATE_FINANCE_REPORT_DETAIL_FAIL:
    case GET_FINANCE_REPORT_FAIL:
    case GET_FINANCE_REPORT_DETAIL_LIST_FAIL:
    case GET_SERVICE_REPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload ? action.payload : "خطای پیش بینی نشده",
        success: "",
      }

    case RESET_FINANCE_REPORT_LST:
      return {
        ...state,
        lstFinanceReport: [],
        lstFinanceReportDetail: [],
      }

    case RESET_FINANCE_REPORT_FLAG:
      return {
        ...state,
        success: null,
        error: null,
        loading: false,
      }
    default:
      return state
  }
}

export default reducer
